import {GET_ALLCOUNTRY_FAILED, GET_ALLCOUNTRY_LOADING, GET_ALLCOUNTRY_SUCCESS } from "../types";
  
  const initialState = {
    loading: false,
    error: null,
    Countries: null,
  };
  
  export const getAllCountryReducer = (
    state = initialState,
    action: { type: any; loading: any; payload: any; error: any }
  ) => {
    switch (action.type) {
      case GET_ALLCOUNTRY_LOADING:
        return {
          ...state,
          loading: action.loading,
          error: null,
        };
      case GET_ALLCOUNTRY_SUCCESS:
        return {
          ...state,
          loading: false,
          Countries: action.payload,
          error: null,
        };
      case GET_ALLCOUNTRY_FAILED:
        return {
          ...state,
          loading: false,
          Countries: null,
          error: action.error,
        };
      default:
        return state;
    }
  };
  